<template>
	<div :style="width" v-if="position > 0">
		<div @mouseover="hover = true" @mouseleave="hover = false" :class="className"></div>
		<div v-if="hover" class="graph-indicator__tooltip">
			<h6 class="mb-0">{{ title }}</h6>
			<p class="mb-0">{{ lowerValue }} - {{ upperValue }}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		maxValue: Number,
		position: Number,
		lowerValue: Number,
		upperValue: Number,
	},
	data() {
		return {
			hover: false,
		};
	},
	computed: {
		className() {
			if (this.position === 1) {
				return "graph-indicator graph-indicator--first";
			}
			if (this.position === 2) {
				return "graph-indicator graph-indicator--second";
			}
			if (this.position === 3) {
				return "graph-indicator graph-indicator--third";
			}
			return "graph-indicator graph-indicator--fourth";
		},
		title() {
			if (this.position === 1) {
				return this.$t('first-quartile');
			}
			if (this.position === 2) {
				return this.$t('second-quartile');
			}
			if (this.position === 3) {
				return this.$t('third-quartile');
			}
			return this.$t('fourth-quartile');
		},
		subtitle() {
			return "subtitle";
		},
		width() {
			const percentageWidth = this.maxValue / 100;
			const totalValue = this.upperValue - this.lowerValue;
			const barWidth = totalValue / percentageWidth;
			return `float: left; width: ${barWidth}%`;
		},
	},
};
</script>
